<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode visualizar as tarefas já encerradas do seu batch.
              Após o prazo máximo estipulado para envio de respostas, a tarefa
              encerra automaticamente, não aceitando mais submissões ou
              atualizações. Em caso de dúvida, pedimos que contate o suporte.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-7 order-1 order-lg-0">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0" v-show="task.title">
                    {{ task.title }}
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="col-12 vld-parent" ref="left_card">
                <div>
                  <h4 class="heading-small text-muted mb-2">
                    Instruções de submissão
                  </h4>
                  <div class="col-12 tv-container-read-only">
                    <quill-editor
                      v-model="task.instructions"
                      :options="editorReadOnly"
                      disabled="disabled"
                    >
                    </quill-editor>
                  </div>
                </div>
                <hr class="my-3" />
                <h4 class="heading-small text-muted mb-2">Resposta</h4>
                <div v-if="task.is_number">
                  <div class="col-lg-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="model.answer_number"
                      placeholder="Tarefa não respondida"
                      :disabled="true"
                    />
                  </div>
                  <hr class="my-3" />

                  <h4 class="heading-small text-muted mb-2">
                    Explicação complementar (opcional)
                  </h4>
                </div>
                <div class="tv-container-read-only col-lg-12">
                  <quill-editor
                    v-model="model.answer_text"
                    :options="editorReadOnly"
                    disabled="disabled"
                  >
                  </quill-editor>
                  <div
                    v-if="isUpdate"
                    class="text-muted text-sm text-right mt-4"
                  >
                    Submetido em:
                    {{ formatDate(model.created_at, "L") }}. Última atualização
                    em: {{ formatDate(model.updated_at, "L") }}.
                  </div>
                  <div v-else class="text-muted text-sm text-right mt-4">
                    A tarefa está encerrada e não está mais aceitando respostas.
                  </div>
                </div>
              </div>
            </template>
          </card>
        </div>
        <div class="col-lg-5 mb-5 mb-lg-0 mt-5 mt-lg-0">
          <card shadow bodyClasses="pb-1">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Batch
                    <span v-if="batch">
                      <span class="text-warning">{{ batch.name }}</span>
                      <router-link
                        :to="`/startup/batches/${batch.id}/acompanhamento`"
                      >
                        <i class="ml-2 fas fa-eye text-sm"></i>
                      </router-link>
                    </span>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="col-12">
                <div class="row">
                  <img
                    class="mx-auto d-block img-fluid mb-4"
                    src="/img/brand/logo_stars_black.png"
                    width="120"
                  />
                </div>
                <div class="row vld-parent" ref="right_card">
                  <div class="col-12">
                    <span class="task-card">
                      <div>
                        <div class="h4 ml-2">
                          {{ task.title }}
                        </div>
                        <div v-show="task.description" class="pb-2">
                          <hr class="my-3" />
                          <div class="col-12 tv-container-read-only">
                            <quill-editor
                              v-model="task.description"
                              :options="editorReadOnly"
                              disabled="disabled"
                            >
                            </quill-editor>
                          </div>
                        </div>
                      </div>
                    </span>
                    <hr class="my-4" />
                    <div>
                      <p v-if="task.deadline" class="text-center mb-2">
                        <i class="far fa-calendar-alt mr-1"></i> Prazo
                        estipulado para a submissão:
                        <span class="d-block text-sm text-center mt-2">
                          <span
                            class="bg-white text-dark rounded border px-2 py-2 font-weight-600"
                            >{{ formatDate(task.deadline, "L") }}</span
                          ></span
                        >
                      </p>
                      <p v-else class="text-center mb-2">
                        <i class="far fa-calendar-alt mr-1"></i> Sem prazo
                        estipulado para submissão
                      </p>
                      <hr class="my-4" />
                      <div class="row text-sm">
                        <div class="col-12 text-center">
                          <p v-if="isUpdate">
                            <i
                              class="text-success fas fa-clipboard-check mr-1"
                            ></i>
                            Você já respondeu a tarefa
                          </p>
                          <p v-else>
                            <i class="text-danger fas fa-clipboard mr-1"></i>
                            Você não respondeu a tarefa
                          </p>
                        </div>
                      </div>
                      <hr class="mt-2 mb-4" />
                      <div class="row text-sm">
                        <div class="col-12 text-center">
                          <p>
                            Esta tarefa não está mais aceitando respostas. Em
                            caso de dúvidas:
                            <span class="d-block text-center mt-2">
                              <base-button
                                @click="$router.push(`/startup/suporte`)"
                                type="danger"
                                size="sm"
                              >
                                <i class="ni ni-support-16"></i>
                                Contate o suporte
                              </base-button>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "tasks_list",
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        answer: "",
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
      task: "",
      batch: "",
      isUpdate: false,
      error: "",
    };
  },
  async mounted() {
    const leftCard = this.$loading.show({
      container: this.$refs.left_card,
      width: 90,
      height: 90,
    });
    const rightCard = this.$loading.show({
      container: this.$refs.right_card,
      width: 90,
      height: 90,
    });
    await this.loadBatch();
    try {
      await this.loadTask();
      leftCard.hide();
      rightCard.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar a tarefa");
    }
  },
  methods: {
    async loadBatch() {
      try {
        const { data: batch } = await api.get(
          `/startup-batches/${this.$route.params.idBatch}`
        );
        if (!batch) {
          this.$toasted.error("Batch não encontrado!");
          this.$router.push("/startup/batches");
          return;
        }
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push("/startup/batches");
      }
    },
    async loadTask() {
      const {
        data: { task, taskResponse },
      } = await api.get(
        `/startup-batches/${this.$route.params.idBatch}/tasks/${this.$route.params.idTask}`
      );
      if (task.status === "open")
        this.$router.push(
          `/startup/batches/${this.$route.params.idBatch}/acompanhamento/tasks/${task.id}/resposta`
        );
      this.task = task;
      if (taskResponse) {
        this.isUpdate = true;
        if (task.is_number)
          taskResponse.answer_number = String(
            taskResponse.answer_number
          ).replace(/\./g, ",");
        this.model = taskResponse;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: block;
  }

  i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: top;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    vertical-align: middle;
  }
}

.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}

.tv-container-read-only .quill-editor .ql-container,
.tv-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 18rem;
  width: 100%;
}
</style>
